import { callsApi } from '../api/calls'
import { messagesApi } from '../api/messages'
import { useCallStore } from '../stores/callStore'

// Маркер системного сообщения-приглашения в групповой звонок.
export const CALL_MSG_PREFIX = '[[call]]'

export interface CallMsgData {
  room_id: string
  call_type: 'voice' | 'video'
}

export function parseCallMessage(text: string): CallMsgData | null {
  if (!text || !text.startsWith(CALL_MSG_PREFIX)) return null
  try {
    return JSON.parse(text.slice(CALL_MSG_PREFIX.length)) as CallMsgData
  } catch {
    return null
  }
}

// Запускает групповой звонок: присоединяется к комнате, открывает экран звонка
// и отправляет в чат системное сообщение с кнопкой «Присоединиться».
export async function startGroupCall(
  chatId: string,
  callType: 'voice' | 'video',
  title: string,
): Promise<void> {
  const res = await callsApi.joinGroupCall(chatId)
  useCallStore.getState().setGroupCall({ roomId: res.room_id, callType, title })
  const payload: CallMsgData = { room_id: res.room_id, call_type: callType }
  messagesApi.send(chatId, { text: CALL_MSG_PREFIX + JSON.stringify(payload) }).catch(() => {})
}

// Присоединяется к уже идущему групповому звонку (без нового системного сообщения).
export async function joinGroupCall(
  chatId: string,
  callType: 'voice' | 'video',
  title: string,
): Promise<void> {
  const res = await callsApi.joinGroupCall(chatId)
  useCallStore.getState().setGroupCall({ roomId: res.room_id, callType, title })
}
